webpackJsonp([96961042003272],{

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 90em;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: 40em) {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n'], ['\n  max-width: 90em;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: 40em) {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin: 2rem 0;\n\n  @media (min-width: 52em) {\n    margin: 3rem -1rem;\n  }\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin: 2rem 0;\n\n  @media (min-width: 52em) {\n    margin: 3rem -1rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  justify-content: ', ';\n\n  @media (min-width: 52em) {\n    width: ', ';\n    order: ', ';\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n'], ['\n  width: 100%;\n  justify-content: ', ';\n\n  @media (min-width: 52em) {\n    width: ', ';\n    order: ', ';\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 1rem;\n  color: #606060;\n  font-size: .875rem;\n\n  @media (min-width: 40em) {\n    padding: 1rem 0;\n  }\n\n  @media (min-width: 52em) {\n    width: 33.33333%;\n    padding: 0 1rem;\n  }\n\n  @media (min-width: 64em) {\n    font-size: 1rem;\n  }\n'], ['\n  width: 100%;\n  padding: 1rem;\n  color: #606060;\n  font-size: .875rem;\n\n  @media (min-width: 40em) {\n    padding: 1rem 0;\n  }\n\n  @media (min-width: 52em) {\n    width: 33.33333%;\n    padding: 0 1rem;\n  }\n\n  @media (min-width: 64em) {\n    font-size: 1rem;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryContainer = _styledComponents2.default.div(_templateObject);
	
	var GalleryItem = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.justify;
	});
	
	var GalleryImage = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.justify;
	}, function (props) {
	  return props.w;
	}, function (props) {
	  return props.order;
	});
	
	var Caption = _styledComponents2.default.div(_templateObject4);
	
	var Gallery = function Gallery(_ref) {
	  var img = _ref.img,
	      index = _ref.index;
	
	  var order = index % 2;
	  var imgWidth = 2 / 3;
	  var justify = 'flex-start';
	
	  if (order === 1) justify = 'flex-end';
	
	  // Narrow container for portrait image
	  if (img.image.sizes.aspectRatio < 1) imgWidth = 1 / 3;
	
	  return _react2.default.createElement(
	    GalleryContainer,
	    null,
	    _react2.default.createElement(
	      GalleryItem,
	      { justify: justify },
	      _react2.default.createElement(
	        GalleryImage,
	        { order: order, justify: justify, w: imgWidth * 100 + '%' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: img.image.sizes })
	      ),
	      _react2.default.createElement(Caption, { dangerouslySetInnerHTML: { __html: img.caption.childMarkdownRemark.html } })
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var images = _ref2.images;
	
	  if (images) return _react2.default.createElement(
	    'div',
	    null,
	    images.map(function (img, index) {
	      return _react2.default.createElement(Gallery, { img: img, index: index, key: index });
	    })
	  );else return false;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 60rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 10vh;\n  padding: 3rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n\n  @media (min-width: 52em) {\n  }\n'], ['\n  max-width: 60rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 10vh;\n  padding: 3rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n\n  @media (min-width: 52em) {\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 48em;\n  padding: 1rem;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  max-width: 48em;\n  padding: 1rem;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-top: 20vh;\n  margin-bottom: 4rem;\n  text-align: center;\n\n  span {\n    display: block;\n    font-size: 2rem;\n    margin-top: 1rem;\n    padding-top: 1rem;\n\n    &:before {\n      position: absolute;\n      left: 50%;\n      content: "";\n      width: 4rem;\n      height: .25rem;\n      margin-top: -1rem;\n      margin-left: -2rem;\n      background-color: rgb(0,186,242);\n    }\n  }\n\n  @media (min-width: 48em) {\n    span {\n      font-size: 3rem;\n    }\n  }\n'], ['\n  position: relative;\n  margin-top: 20vh;\n  margin-bottom: 4rem;\n  text-align: center;\n\n  span {\n    display: block;\n    font-size: 2rem;\n    margin-top: 1rem;\n    padding-top: 1rem;\n\n    &:before {\n      position: absolute;\n      left: 50%;\n      content: "";\n      width: 4rem;\n      height: .25rem;\n      margin-top: -1rem;\n      margin-left: -2rem;\n      background-color: rgb(0,186,242);\n    }\n  }\n\n  @media (min-width: 48em) {\n    span {\n      font-size: 3rem;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  max-width: 64em;\n  margin: 3rem auto;\n  padding: 1rem;\n\n  @media (min-width: 40em) {\n    padding: 2rem;\n  }\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  max-width: 64em;\n  margin: 3rem auto;\n  padding: 1rem;\n\n  @media (min-width: 40em) {\n    padding: 2rem;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  max-width: 52em;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n\n  @media (min-width: 40em) {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n'], ['\n  max-width: 52em;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n\n  @media (min-width: 40em) {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  @media (min-width: 52em) {\n    font-size: 1.25rem;\n  }\n'], ['\n  @media (min-width: 52em) {\n    font-size: 1.25rem;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0;\n\n  @media (min-width: 40em) {\n    padding: 2rem 0;\n  }\n\n  @media (min-width: 52em) {\n    padding: 3rem 0;\n  }\n'], ['\n  padding: 1rem 0;\n\n  @media (min-width: 40em) {\n    padding: 2rem 0;\n  }\n\n  @media (min-width: 52em) {\n    padding: 3rem 0;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n\n  @media (min-width: 52em) {\n    width: 50%;\n  }\n'], ['\n  width: 100%;\n\n  @media (min-width: 52em) {\n    width: 50%;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin-top: 1rem;\n  color: #606060;\n  font-size: .875rem;\n\n  @media (min-width: 52em) {\n    width: 50%;\n    margin-top: 0;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    font-size: 1rem;\n  }\n'], ['\n  width: 100%;\n  margin-top: 1rem;\n  color: #606060;\n  font-size: .875rem;\n\n  @media (min-width: 52em) {\n    width: 50%;\n    margin-top: 0;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    font-size: 1rem;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n\n  @media (min-width: 40em) {\n    display: flex;\n  }\n'], ['\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n\n  @media (min-width: 40em) {\n    display: flex;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  text-align: center;\n\n  @media (min-width: 40em) {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 50%;\n    padding: 2rem;\n    border-left: 1px solid #ddd;\n  }\n'], ['\n  width: 100%;\n  text-align: center;\n\n  @media (min-width: 40em) {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 50%;\n    padding: 2rem;\n    border-left: 1px solid #ddd;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  color: #303030;\n  text-decoration: none;\n\n  p {\n    margin: 0;\n  }\n'], ['\n  color: #303030;\n  text-decoration: none;\n\n  p {\n    margin: 0;\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  max-width: 10em;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  max-width: 10em;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  font-size: 1rem;\n  margin-bottom: 0;\n  margin-top: 1rem;\n\n  @media (min-width: 52em) {\n    font-size: 1.25rem;\n  }\n\n  @media (min-width: 64em) {\n    font-size: 1.5rem;\n  }\n'], ['\n  font-size: 1rem;\n  margin-bottom: 0;\n  margin-top: 1rem;\n\n  @media (min-width: 52em) {\n    font-size: 1.25rem;\n  }\n\n  @media (min-width: 64em) {\n    font-size: 1.5rem;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gallery = __webpack_require__(281);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _i18n = __webpack_require__(37);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject);
	
	var PageTitle = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h1(_templateObject3);
	
	var PageHero = _styledComponents2.default.div(_templateObject4);
	
	var Body = _styledComponents2.default.div(_templateObject5);
	
	var BodyText = _styledComponents2.default.div(_templateObject6);
	
	var PageGallery = _styledComponents2.default.div(_templateObject7);
	
	var PageHeroImage = _styledComponents2.default.div(_templateObject8);
	
	var PageHeroCaption = _styledComponents2.default.div(_templateObject9);
	
	var PageNavigation = _styledComponents2.default.div(_templateObject10);
	
	var NavItem = _styledComponents2.default.div(_templateObject11);
	
	var NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject12);
	
	var NavImg = (0, _styledComponents2.default)(_gatsbyImage2.default)(_templateObject13);
	
	var NavHeading = _styledComponents2.default.h4(_templateObject14);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var page = data.contentfulPage;
	  var pages = data.pages.edges.filter(function (item) {
	    return item.node.node_locale === page.node_locale;
	  });
	  var pageTitle = page.title + " - " + page.subtitle;
	
	  if (_i18n2.default.language != page.node_locale) _i18n2.default.changeLanguage(page.node_locale);
	
	  var prev = void 0,
	      next = null;
	
	  pages.forEach(function (item, index) {
	    if (item.node.id == page.id) {
	      if (index > 0) prev = index - 1;
	      if (index < pages.length - 1) next = index + 1;
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: pageTitle,
	      meta: [{ name: 'description', content: 'Itsenäisen Suomen poliisi' }, { name: 'keywords', content: 'poliisimuseo, poliisi, verkkonäyttely, itsenäisen suomen poliisi' }]
	    }),
	    _react2.default.createElement(
	      PageTitle,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        _react2.default.createElement(
	          'small',
	          null,
	          page.title
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          page.subtitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      PageHero,
	      null,
	      _react2.default.createElement(
	        PageHeroImage,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: page.image.sizes })
	      ),
	      _react2.default.createElement(
	        PageHeroCaption,
	        null,
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: page.imageCaption.childMarkdownRemark.html } })
	      )
	    ),
	    _react2.default.createElement(
	      Body,
	      null,
	      _react2.default.createElement(BodyText, { dangerouslySetInnerHTML: { __html: page.body.childMarkdownRemark.html } })
	    ),
	    _react2.default.createElement(
	      PageGallery,
	      null,
	      _react2.default.createElement(_gallery2.default, { images: page.imageGallery })
	    ),
	    _react2.default.createElement(
	      PageNavigation,
	      null,
	      prev && _react2.default.createElement(
	        NavItem,
	        null,
	        _react2.default.createElement(
	          NavLink,
	          { to: pages[prev].node.slug },
	          _react2.default.createElement(NavImg, { sizes: pages[prev].node.image.sizes }),
	          _react2.default.createElement(
	            NavHeading,
	            null,
	            pages[prev].node.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            pages[prev].node.subtitle
	          )
	        )
	      ),
	      next && _react2.default.createElement(
	        NavItem,
	        null,
	        _react2.default.createElement(
	          NavLink,
	          { to: pages[next].node.slug },
	          _react2.default.createElement(NavImg, { sizes: pages[next].node.image.sizes }),
	          _react2.default.createElement(
	            NavHeading,
	            null,
	            pages[next].node.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            pages[next].node.subtitle
	          )
	        )
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-d2229873d16f7ec66105.js